(function () {
	const STORAGE_KEY = 'cart_drawer_discount_code';

	// ── Helpers ───────────────────────────────────────────────────────────────
	// Always query the DOM fresh — elements are replaced on every cart re-render
	function getApplyBtn()   { return document.getElementById('CartDrawer-DiscountApply'); }
	function getCodeInput()  { return document.getElementById('CartDrawer-DiscountCode'); }
	function getMessage()    { return document.getElementById('CartDrawer-DiscountMessage'); }
	function getCheckoutBtn(){ return document.getElementById('CartDrawer-Checkout'); }

	function setMessage(type, text) {
		const message = getMessage();
		if (!message) return;
		message.textContent = text;
		message.className = 'cart-drawer__discount-message';
		if (type === 'success') message.classList.add('cart-drawer__discount-message--success');
		if (type === 'error')   message.classList.add('cart-drawer__discount-message--error');
	}

	function updateCheckoutUrl(code) {
		const checkoutBtn = getCheckoutBtn();
		if (!checkoutBtn) return;
		const base = checkoutBtn.getAttribute('data-checkout-url') || '/checkout';
		checkoutBtn.onclick = function () {
			window.location.href = code ? base + '?discount=' + encodeURIComponent(code) : base;
		};
	}

	function handleApply() {
		const codeInput = getCodeInput();
		const applyBtn  = getApplyBtn();
		const code = codeInput ? codeInput.value.trim() : '';

		if (!code) {
			sessionStorage.removeItem(STORAGE_KEY);
			updateCheckoutUrl('');
			setMessage('error', 'Please enter a discount code.');
			return;
		}

		setMessage('', 'Checking code\u2026');
		if (applyBtn) applyBtn.disabled = true;

		const fetchStart = performance.now();
		console.log('[CartDrawer] Applying discount code "' + code + '" via /cart/update.js');

		// POST the discount code to the cart, then read back cart_level_discount_applications
		// to determine whether Shopify actually honoured it. The /discount/ redirect URL
		// always returns 200 regardless of validity so cannot be used for validation.
		fetch('/cart/update.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: JSON.stringify({ discount: code })
		})
		.then(function (res) {
			const elapsed = (performance.now() - fetchStart).toFixed(0) + 'ms';
			console.log('[CartDrawer] /cart/update.js responded in ' + elapsed + ' — HTTP ' + res.status);
			return res.json();
		})
		.then(function (cart) {
			console.log('[CartDrawer] cart_level_discount_applications:', cart.cart_level_discount_applications);
			const applied = Array.isArray(cart.cart_level_discount_applications) &&
				cart.cart_level_discount_applications.some(function (d) {
					// The title may be directly on the object or nested under discount_application
					// depending on whether the discount is cart-level or line-item-level
					const title = (d.title) || (d.discount_application && d.discount_application.title);
					return title && title.toUpperCase() === code.toUpperCase();
				});

			if (applied) {
				console.log('[CartDrawer] Code "' + code + '" confirmed valid — updating checkout URL');
				sessionStorage.setItem(STORAGE_KEY, code);
				updateCheckoutUrl(code);
				setMessage('success', '\u2713 Code "' + code + '" will be applied at checkout');
			} else {
				console.warn('[CartDrawer] Code "' + code + '" not found in discount applications — treating as invalid');
				sessionStorage.removeItem(STORAGE_KEY);
				updateCheckoutUrl('');
				setMessage('error', 'That code is invalid or has expired.');
			}
		})
		.catch(function (err) {
			const elapsed = (performance.now() - fetchStart).toFixed(0) + 'ms';
			console.error('[CartDrawer] Fetch failed after ' + elapsed + ':', err);
			setMessage('error', 'Something went wrong. Please try again.');
		})
		.finally(function () {
			const elapsed = (performance.now() - fetchStart).toFixed(0) + 'ms';
			console.log('[CartDrawer] Discount validation complete in ' + elapsed);
			const btn = getApplyBtn();
			if (btn) btn.disabled = false;
		});
	}

	// ── Restore saved code into freshly rendered DOM ──────────────────────────
	function restoreSavedCode() {
		const savedCode = sessionStorage.getItem(STORAGE_KEY);
		const codeInput = getCodeInput();
		if (!savedCode || !codeInput) return;
		codeInput.value = savedCode;
		setMessage('success', '\u2713 Code "' + savedCode + '" will be applied at checkout');
		updateCheckoutUrl(savedCode);
	}

	// ── Event delegation — attached once to <cart-drawer> which persists ──────
	// cart-drawer.js replaces #CartDrawer innerHTML on every render, but the
	// <cart-drawer> custom element itself is never removed from the DOM.
	const cartDrawerEl = document.querySelector('cart-drawer');
	if (cartDrawerEl) {
		cartDrawerEl.addEventListener('click', function (e) {
			if (e.target.closest('#CartDrawer-DiscountApply')) {
				handleApply();
			}
		});
		cartDrawerEl.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' && e.target.id === 'CartDrawer-DiscountCode') {
				handleApply();
			}
		});
	}

	// ── Re-initialise after every cart re-render ──────────────────────────────
	// cart.js dispatches 'cart:change' after each successful cart update,
	// by which point cart-drawer.js has already replaced the drawer's innerHTML.
	document.addEventListener('cart:change', function () {
		console.log('[CartDrawer] cart:change received — restoring discount state');
		restoreSavedCode();
	});

	// ── Initial page load ─────────────────────────────────────────────────────
	restoreSavedCode();
})();
